import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Catalog } from '@df/catalog/catalog.interfaces';
import { CustomerAttributeResource } from '@df/catalog/customer-attribute/customer-attribute.resource';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { MuiInputDirective } from '../../../module/legacy/forms/mui-input.directive';
import { InputWrapBodyDirective } from '../../../ui/form/input-wrap-body.directive';
import { InputWrapComponent } from '../../../ui/form/input-wrap.component';
import { AbstractEditFormComponent } from '../form/abstract-edit-form.component';
import { AccountEditFormLayoutComponent } from '../form/layout/account-edit-form-layout.component';
@Component({
    selector: 'account-edit-preferred-store',
    templateUrl: './account-edit-preferred-store.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [FormsModule, InputWrapComponent, TranslationModule, AccountEditFormLayoutComponent, MuiInputDirective, InputWrapBodyDirective]
})
export class AccountEditPreferredStoreComponent extends AbstractEditFormComponent {
    private customerAttributeResource = inject(CustomerAttributeResource);
    options?: Catalog.ICustomerAttributeOption[];
    override ngOnInit(): void {
        super.ngOnInit();
        const preferredStoreAttribute = this.customerAttributeResource.get('preferred_store');
        this.options = preferredStoreAttribute.options;
        this.detectChanges();
    }
}
